import { fromGender } from "@/src/services/formServiceFunctions";
import React from "react";
import summaryStyle from "./summaryStyle";
import Grid from "@mui/material/Grid";
import { translate } from "@/src/services/translations/translations";
import Typography from "@mui/material/Typography";
import { isInsurerPartnered } from "@/src/services/productService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";

type InsuranceDataProps = {
  formData: Record<string, any>;
  product: AbstractCase;
  title: string;
};

const InsuranceData = ({ formData, product, title }: InsuranceDataProps) => {

  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}>{title}</Typography>
      </Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"name"} />
        <strong>Versicherung</strong>
      </Grid>
      <Grid size={12}>{product.caseInsurance.insurer?.name}</Grid>
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"insurancePolicyNumber"} />
        <strong>Versicherungsnummer</strong>
      </Grid>
      <Grid size={12}>{formData.caseInsurance.insurancePolicyNumber}</Grid>
      {!isInsurerPartnered(product) && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"caseReferenceNumber"} />
            <strong>Schadennummer</strong>
          </Grid>
          <Grid size={12}>{formData.caseInsurance.caseReferenceNumber}</Grid>
        </>
      )}
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"policyHolderType"} />
        <strong>Selbst oder mitversichert</strong>
      </Grid>
      <Grid size={12}>{translate(`${product.name}.caseInsurance.policyHolderType.options.${formData.caseInsurance.policyHolderType}.label`, formData)}</Grid>
      {formData.caseInsurance.policyHolderType === "familyMember" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"gender"} />
            <strong>Anrede Versicherter</strong>
          </Grid>
          <Grid size={12}>{fromGender(formData.caseInsurance.policyHolder.gender) || "Keine Anrede"}</Grid>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"givenName"} />
            <strong>Vorname Versicherter</strong>
          </Grid>
          <Grid size={12}>{formData.caseInsurance.policyHolder.givenName}</Grid>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"familyName"} />
            <strong>Nachname Versicherter</strong>
          </Grid>
          <Grid size={12}>{formData.caseInsurance.policyHolder.familyName}</Grid>
        </>
      )}
    </>
  );
};

export default InsuranceData;
